import { BaseRequest } from '../../BaseRequest';

export class UpdateCandidateVacancyRequest extends BaseRequest {
  id: number;
  timestamp?: number;
  acl?: string;
  candidate?: number;
  client?: number;
  priority?: number;
  contacted?: number;
  contactedDate?: Date;
  contactedNote?: string;
  interested?: number;
  interestedDate?: Date;
  interestedNote?: string;
  CVProvidedToClient?: number;
  CVProvidedToClientDate?: Date;
  CVProvidedToClientNote?: string;
  interviewed?: number;
  interviewedDate?: Date;
  interviewedNote?: string;
  offered?: number;
  offeredDate?: Date;
  offeredNote?: string;
  accepted?: number;
  acceptedDate?: Date;
  acceptedNote?: string;
  rejected?: number;
  rejectedDate?: Date;
  rejectedNote?: string;
  name?: string;
  visit1?: number;
  visit1Date?: Date;
  visit1Note?: string;
  visit2?: number;
  visit2Date?: Date;
  visit2Note?: string;

  constructor(
    server: string,
    sessionId: string,
    id: number,
    timestamp?: number,
    acl?: string,
    candidate?: number,
    client?: number,
    priority?: number,
    contacted?: number,
    contactedDate?: Date,
    contactedNote?: string,
    interested?: number,
    interestedDate?: Date,
    interestedNote?: string,
    CVProvidedToClient?: number,
    CVProvidedToClientDate?: Date,
    CVProvidedToClientNote?: string,
    interviewed?: number,
    interviewedDate?: Date,
    interviewedNote?: string,
    offered?: number,
    offeredDate?: Date,
    offeredNote?: string,
    accepted?: number,
    acceptedDate?: Date,
    acceptedNote?: string,
    rejected?: number,
    rejectedDate?: Date,
    rejectedNote?: string,
    name?: string,
    visit1?: number,
    visit1Date?: Date,
    visit1Note?: string,
    visit2?: number,
    visit2Date?: Date,
    visit2Note?: string
  ) {
    super(server, sessionId);
    this.id = id;
    this.timestamp = timestamp;
    this.acl = acl;
    this.candidate = candidate;
    this.client = client;
    this.priority = priority;
    this.contacted = contacted;
    this.contactedDate = contactedDate;
    this.contactedNote = contactedNote;
    this.interested = interested;
    this.interestedDate = interestedDate;
    this.interestedNote = interestedNote;
    this.CVProvidedToClient = CVProvidedToClient;
    this.CVProvidedToClientDate = CVProvidedToClientDate;
    this.CVProvidedToClientNote = CVProvidedToClientNote;
    this.interviewed = interviewed;
    this.interviewedDate = interviewedDate;
    this.interviewedNote = interviewedNote;
    this.offered = offered;
    this.offeredDate = offeredDate;
    this.offeredNote = offeredNote;
    this.accepted = accepted;
    this.acceptedDate = acceptedDate;
    this.acceptedNote = acceptedNote;
    this.rejected = rejected;
    this.rejectedDate = rejectedDate;
    this.rejectedNote = rejectedNote;
    this.name = name;
    this.visit1 = visit1;
    this.visit1Date = visit1Date;
    this.visit1Note = visit1Note;
    this.visit2 = visit2;
    this.visit2Date = visit2Date;
    this.visit2Note = visit2Note;
  }

  override toXml(): string {
    var parameters = super.toXml();
    parameters += this.makeNode(this.id, 'id');
    parameters += this.makeNode(this.timestamp, 'timestamp');
    parameters += this.makeNode(this.acl, 'acl');
    parameters += this.makeNode(this.candidate, 'candidate');
    parameters += this.makeNode(this.client, 'client');
    parameters += this.makeNode(this.priority, 'priority');
    parameters += this.makeNode(this.contacted, 'contacted');
    parameters += this.makeNode(this.contactedDate, 'contactedDate');
    parameters += this.makeNode(this.contactedNote, 'contactedNote');
    parameters += this.makeNode(this.interested, 'interested');
    parameters += this.makeNode(this.interestedDate, 'interestedDate');
    parameters += this.makeNode(this.interestedNote, 'interestedNote');
    parameters += this.makeNode(this.CVProvidedToClient, 'CVProvidedToClient');
    parameters += this.makeNode(this.CVProvidedToClientDate, 'CVProvidedToClientDate');
    parameters += this.makeNode(this.CVProvidedToClientNote, 'CVProvidedToClientNote');
    parameters += this.makeNode(this.interviewed, 'interviewed');
    parameters += this.makeNode(this.interviewedDate, 'interviewedDate');
    parameters += this.makeNode(this.interviewedNote, 'interviewedNote');
    parameters += this.makeNode(this.offered, 'offered');
    parameters += this.makeNode(this.offeredDate, 'offeredDate');
    parameters += this.makeNode(this.offeredNote, 'offeredNote');
    parameters += this.makeNode(this.accepted, 'accepted');
    parameters += this.makeNode(this.acceptedDate, 'acceptedDate');
    parameters += this.makeNode(this.acceptedNote, 'acceptedNote');
    parameters += this.makeNode(this.rejected, 'rejected');
    parameters += this.makeNode(this.rejectedDate, 'rejectedDate');
    parameters += this.makeNode(this.rejectedNote, 'rejectedNote');
    parameters += this.makeNode(this.name, 'name');
    parameters += this.makeNode(this.visit1, 'visit1');
    parameters += this.makeNode(this.visit1Date, 'visit1Date');
    parameters += this.makeNode(this.visit1Note, 'visit1Note');
    parameters += this.makeNode(this.visit2, 'visit2');
    parameters += this.makeNode(this.visit2Date, 'visit2Date');
    parameters += this.makeNode(this.visit2Note, 'visit2Note');

    return super.wrapperXml('UpdateCandidateVacancy', parameters);
  }
}
